module.exports = __webpack_public_path__ + "img/web_tiny.113014a2.png";